export default {
  logouted: 'auth.logouted',
  forbidden: 'auth.forbidden',
  notFound: 'notFound',
};
